/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cancelMicroAuthCheck} from '../api'

export const useMutationCancelMicroAuthCheck = createReactQueryMutationHook('cancelMicroAuthCheck', cancelMicroAuthCheck)
